export const RitualSteps = () => (
<div className="bg-gradient-to-br from-red-900/30 to-red-950/30 p-8 rounded-2xl border-2 border-red-600/40 my-8">
              <h3 className="text-2xl font-bold text-yellow-400 mb-4">Les Étapes du Rituel</h3>
              <ol className="space-y-4 text-gray-300">
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">1.</span>
                  <span><strong className="text-white">Consultation gratuite</strong> pour analyser votre situation</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">2.</span>
                  <span><strong className="text-white">Préparation du rituel</strong> avec objets personnels si disponibles</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">3.</span>
                  <span><strong className="text-white">Exécution du rituel vaudou</strong> par le marabout africain</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">4.</span>
                  <span><strong className="text-white">Premiers résultats sous 3 à 7 jours</strong> (votre ex pense à vous, vous contacte)</span>
                </li>
                <li className="flex items-start">
                  <span className="text-red-500 font-bold mr-3">5.</span>
                  <span><strong className="text-white">Retour complet sous 3-21 jours</strong> selon complexité</span>
                </li>
              </ol>
            </div>
);
